import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Clubstate } from '../interfaces/clubstate';
import { environment } from 'src/environments/environment';
import { Observable, filter, map, tap } from 'rxjs';
/**
 * Servie used to set/get/edit Clubstates (currently only bielefeld(123))
 */
@Injectable({
  providedIn: 'root'
})
export class ClubstateService {
  /**
   * constructor
   * @param http 
   */
  constructor(
    private http: HttpClient) {

  }
  /**
   * Get one State by ID
   * @param stateID 
   * @returns 
   */
  getOneState(stateID: String) {
    return this.http.get(`https://bxbrjn1zba.execute-api.eu-central-1.amazonaws.com/stageTest/api/v1/status/${stateID}`);
  }
  /**
   * Get all States
   * @returns
   */
  getAllStates() {
    return this.http.get(`https://bxbrjn1zba.execute-api.eu-central-1.amazonaws.com/stageTest/api/v1/status`);
  }
  /**
   * Edit one State
   * @param stateObj 
   * @returns 
   */
  editOneState(stateObj) {
    return this.http.put(`https://bxbrjn1zba.execute-api.eu-central-1.amazonaws.com/stageTest/api/v1/status`, stateObj);
  }
  /**
   * Create a new State
   * @param stateObj 
   * @returns 
   */
  addNewState(stateObj) {
    return this.http.post(`https://bxbrjn1zba.execute-api.eu-central-1.amazonaws.com/stageTest/api/v1/status`, stateObj);
  }
  /**
   * Delete a State
   * @param stateID 
   * @returns 
   */
  delteState(stateID: String) {
    const body = {
      'id': stateID
    }
    return this.http.delete(`https://bxbrjn1zba.execute-api.eu-central-1.amazonaws.com/stageTest/api/v1/status`, { body });
  }


    /**
   * Get all States
   * @returns
   */
    getAllStatesForClientID():Observable<any> {
      return this.http.get<Array<Clubstate>>(`https://bxbrjn1zba.execute-api.eu-central-1.amazonaws.com/stageTest/api/v1/status`).pipe(
        map(arr => arr.filter(item => item.clientId == environment.clientID))
      );
    }
}
